import React from 'react'


export default class extends React.Component {

  render() {
    document.title = "INFLOW Online Marketing Google Reviews - Peter van der Meer - Helpt jouw bedrijf groeien.";
    
    var headTag = document.getElementsByTagName('head')[0];
    var charsetTag = document.createElement('meta');
    charsetTag.setAttribute("http-equiv", "refresh");
    charsetTag.setAttribute("content", "0; URL='https://g.page/r/Cbl74Rfhb-zrEAE/review'");
    headTag.appendChild(charsetTag);

    return (
      <div style={{margin:"3em"}}>Je wordt doorgestuurd naar <a href="https://g.page/r/Cbl74Rfhb-zrEAE/review">g.page/r/Cbl74Rfhb-zrEAE/review</a> (Google Reviews)</div>
      );
  }

}



// WEBPACK FOOTER //
// ./src/containers/redir_gmb.js